import {defineStore} from 'pinia'
import {useMenuItemApi} from '~/composables/api/useMenuItemApi'
import {useConfigApi} from '~/composables/api/useConfigApi'
import {useAuthStore} from '~/store/auth'
import {cloneDeep} from 'lodash'

export const useConfigStore = defineStore('config', {
  state: () => ({
    menus: [],
    paymentPlatform: 'redsys',
    redsysScript: '',
    redsysTerminal: '',
    redsysMerchantCode: '',
    email: '',
    phone: '',
    phoneAlt: '',
    address: '',
    scheduleTable: '',
    tradeName: '',
    facebookLink: '',
    instagramLink: '',
    youtubeLink: '',
    tiktokLink: '',
  }),

  actions: {
    async load() {
      const menuItemApi = useMenuItemApi()
      const configApi = useConfigApi()
      try {
        const [menus, configs] = await Promise.all([menuItemApi.load(), configApi.load()])
        this.menus = menus
        for (const key in configs) {
          this[key] = configs[key]
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  getters: {
    getMenuItems: (state) => (slot = null) => {
      if (!slot) return []

      const slotItems = state.menus?.[slot] || []

      const authStore = useAuthStore()
      const isAuth = authStore.isAuth

      let filteredItems = cloneDeep(slotItems)
      if (isAuth) {
        filteredItems = filteredItems.filter(item => !item.metadata.requiresAuth ||
          (item.metadata.requiresAuth && item.metadata.roles.length > 0 && item.metadata.roles.some(role => authStore.user.roles.includes(role)))
        )
      } else {
        filteredItems = filteredItems.filter(item => !item.metadata.requiresAuth)
      }

      return filteredItems
    },
    contactData: (state) => {
      return {
        email: state.email || '',
        phone: state.phone || '',
        phoneAlt: state.phoneAlt || '',
        address: state.address || '',
        scheduleTable: state.scheduleTable || '',
        tradeName: state.tradeName || '',
        facebookLink: state.facebookLink || '',
        instagramLink: state.instagramLink || '',
        youtubeLink: state.youtubeLink || '',
        tiktokLink: state.tiktokLink || '',
      }
    }
  }
})
